// extracted by mini-css-extract-plugin
module.exports = {"description":"PropertiesCategory_description__fLmC0"};